import React from 'react';
import SeparatorBar from './SeparatorBar';
import { parseNumber } from 'utils/parser';
import { useGetBasicUomEnum } from 'hooks';
import { getUomTypesAbbreviations } from '../DailyValueConstants';

function NutrientRowNew({ nutrient, labelItalic }) {
  const {
    dailyValueIntakePercent,
    percentBold,
    indentBar,
    indent,
    labelBold,
    quantity,
    quantityUom,
    bottomBar,
    nutritionName,
    bottomBarHeight,
    topBarHeight,
    topBar,
    hightLightText,
  } = nutrient ?? {};

  const { basicUomProperties } = useGetBasicUomEnum();

  const showAbbr = (quantityUom, defaultUom = 'g') => {
    return (
      getUomTypesAbbreviations(basicUomProperties, quantityUom) ?? defaultUom
    );
  };

  const percent = parseNumber(dailyValueIntakePercent);
  const gram = `${parseNumber(quantity)}${showAbbr(quantityUom, 'g')}`;

  const indentLabel = indent ? `${indent}px` : '0';
  const labelWeight = labelBold ? 900 : 400;
  const percentWeight = percentBold ? 900 : 400;
  const indentDiv = indentBar ? `${indentBar}px` : indentLabel;

  const styles = {
    div: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: indentDiv,
    },
    label: {
      fontWeight: labelWeight,
      fontStyle: labelItalic ? 'italic' : '',
    },
    percent: {
      fontWeight: percentWeight,
    },
    gram: {
      paddingLeft: '5px',
    },
    indent: {
      backgroundColor: hightLightText,
    },
  };

  return (
    <div className='nutrition-facts__nutrition-row' style={styles.indent}>
      {topBar ? null : (
        <SeparatorBar indentBar={indentBar || 0} height={topBarHeight || 0} />
      )}
      <div style={styles.div}>
        <div className='nutrition-facts__nutrition-row_name'>
          <div style={styles.label}>{nutritionName}</div>
          <div style={styles.gram}>{gram}</div>
        </div>
        <div style={styles.percent}>
          {percent != null && percent !== undefined ? `${percent}%` : null}
        </div>
      </div>
      {bottomBar && (
        <SeparatorBar
          indentBar={indentBar || 0}
          height={bottomBarHeight || 0}
        />
      )}
    </div>
  );
}

export default NutrientRowNew;
